import { ShieldAlert, ShieldCheck, ShieldX } from 'lucide-react';
import { Badge } from './Badge.tsx';

export type RiskLevel = 'low' | 'medium' | 'high';

export const RISK_LABEL: Record<RiskLevel, string> = { low: 'Low risk', medium: 'Medium risk', high: 'High risk' };

/** What a risk level means for the person about to act. */
export const RISK_HINT: Record<RiskLevel, string> = {
  low: 'Runs at once.',
  medium: 'Runs at once and can be undone for a few seconds.',
  high: 'Asks you to confirm by name before it runs. Policy still applies.',
};

/** Risk as icon plus label, never colour alone. */
export function RiskBadge({ risk, className, compact }: { risk: RiskLevel; className?: string; compact?: boolean }) {
  const Icon = risk === 'high' ? ShieldX : risk === 'medium' ? ShieldAlert : ShieldCheck;
  return (
    <Badge tone={risk === 'high' ? 'failed' : risk === 'medium' ? 'waiting' : 'neutral'} icon={<Icon />} className={className}>
      {compact ? risk[0]!.toUpperCase() + risk.slice(1) : RISK_LABEL[risk]}
    </Badge>
  );
}
